module.exports = __webpack_public_path__ + "static/media/SR.636cd188.png";